import clsx from 'clsx';
import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { Icon } from '../display/Icon.tsx';
import styles from './Badge.module.css';

export type BadgeTone = 'neutral' | 'accent' | 'success' | 'warning' | 'danger';

export interface BadgeProps {
  readonly tone?: BadgeTone | undefined;
  readonly icon?: LucideIcon | undefined;
  readonly children: ReactNode;
  readonly className?: string | undefined;
}

/** Short status label. */
export const Badge = ({ tone = 'neutral', icon, children, className }: BadgeProps) => (
  <span className={clsx(styles.badge, styles[tone], className)}>
    {icon && <Icon icon={icon} size="sm" />}
    <span className={styles.text}>{children}</span>
  </span>
);
